import NotificationService from 'services/notificationService';
import { z } from 'zod';

const sendGridTemplateSchema = z.object({
  versions: z.array(
    z.object({
      active: z.number(),
      plain_content: z.string().optional(),
    })
  ),
});

const GetSendGridTemplate = async (
  getAuthToken: () => Promise<string | void>,
  templateName: string
) => {
  const authToken = await getAuthToken();
  if (!authToken) throw new Error('Sign in to load the email preview.');

  const service = new NotificationService(authToken);
  const result = await service.notificationService.get('GetSendGridTemplate', { templateName });

  const template: unknown = typeof result.data === 'string' ? JSON.parse(result.data) : result.data;
  return sendGridTemplateSchema.parse(template);
};

export default GetSendGridTemplate;
